/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useCallback } from 'react';
import { withRouter } from 'react-router';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import { Box, MenuItem } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
// variable custom import
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import * as commonConstant from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import { navigateToRequest } from '../../QuarterlyPayment/components/ConstantData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  redirectURLLink,
  quarterTest1,
  quarterTest2,
  handleScrollToEvent,
  checkQuarterValidation,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  STATUS_MSG,
  SUCCESS_MSG,
  REBATE_PROGRAM_REQUIRED,
  VALIDATE_QUARTER_VALUE,
  QUARTER_VALUE_REQUIRED,
  PERCENT_ALLOWED_AMOUNT_REQ_LESS_THAN_100,
  NO_DATA,
} from '../../../../SharedModules/Errors/constantMessageData';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  dispatchErrorMsgInvQtrnotPaid,
  getPlanTypeValues,
  getRebateProgrameList,
  invoicesQtrnotPaidDetailObj,
  invoicesQtrnotPaidObj,
  getInvoiceQuarternotPaid,
  dispatchDisplayInputField,
  getMaxQuarterValue,
  showNoDataMessage,
  setExtraStateForInvoiceForQtrNotPaid,
} from '../store/action';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';

function RequestInvoicesQtrnotPaid(props) {
  const dispatch = useDispatch();
  const gridRef = React.useRef();
  const history = useHistory();

  // use Selector function
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const requestCurrentDisData = useSelector(
    (state) =>
      state?.sharedState?.InvoicesforQtrnotPaidReducer?.invoicesQtrnotPaidObj
        ?.state
  );

  const extraState = useSelector(
    (state) => state?.sharedState?.InvoicesforQtrnotPaidReducer?.extraState
  );
  const planTypeList = useSelector(
    (state) => state?.sharedState?.InvoicesforQtrnotPaidReducer?.planType
  );

  const getQuarterDataValue = useSelector(
    (state) => state?.sharedState?.InvoicesforQtrnotPaidReducer?.quarter
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const resultList = useSelector(
    (state) => state?.sharedState?.InvoicesforQtrnotPaidReducer?.searchResult
  );
  const getErrorMsg = useSelector(
    (state) =>
      state?.sharedState?.InvoicesforQtrnotPaidReducer?.errorMsgQtrlyPayment
  );
  const displayScreenData = useSelector(
    (state) => state?.sharedState?.InvoicesforQtrnotPaidReducer?.displayData
  );
  // states with initial values
  const [state, setState] = React.useState(
    requestCurrentDisData || {
      planTypeCd: userDefaults?.planTypeCd ? userDefaults?.planTypeCd : 'FD',
      rebateProgramCd: userDefaults?.rebateProgramCd
        ? userDefaults?.rebateProgramCd
        : '-1',
      quarterValue: '',
    }
  );
  const [radioList, setRadioList] = React.useState([]);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  // filtering data intial states
  const [payValue, setPayValue] = React.useState(displayScreenData.payValue);

  const [checkBoxValues, setCheckBoxValues] = React.useState({
    exUnThreshMailed: displayScreenData?.exUnThreshMailed,
    incZeroURA: displayScreenData?.incZeroURA,
    excDecBalWtnOff: displayScreenData?.excDecBalWtnOff,
  });
  const [amtPercent, setAmtPercent] = React.useState(
    displayScreenData?.amtPercent
  );

  // for save changes and dispatch function
  const setInvQtrnotPaidScrData = (value) => {
    setState({ ...requestCurrentDisData, ...value });
    dispatch(
      invoicesQtrnotPaidObj({ state: { ...requestCurrentDisData, ...value } })
    );
  };

  // set Rebate Program List
  const getRebateProgram = async (planType) => {
    const newState = _.cloneDeep(requestCurrentDisData);
    if (planType) {
      const getRebateProgramList = await dispatch(
        getRebateProgrameList(planType)
      );
      let list = [];
      if (
        getRebateProgramList?.status === STATUS_MSG &&
        getRebateProgramList?.message === SUCCESS_MSG
      ) {
        if (!_.isEmpty(getRebateProgramList.data)) {
          list = _.map(getRebateProgramList.data, (val) => ({
            ...val,
            id: val.rebateProgramCd,
            name: `${val.rebateProgramCd} | ${val.shortDescr}`,
          }));
        }
      }
      setRebateProgramList(
        list.sort((key, val) =>
          key.name.toLowerCase().localeCompare(val.name.toLowerCase())
        )
      );
      const getRebate =
        !_.isEmpty(list) && requestCurrentDisData?.rebateProgramCd
          ? _.filter(list, (l) => l.id === state?.rebateProgramCd)
          : [];
      const newVal = !_.isEmpty(getRebate)
        ? getRebate[0]
        : { id: '-1', name: '' };
      newState.rebateProgramCd = newVal.id;
      newState.rebateName = newVal.name;
      if (_.isEmpty(requestCurrentDisData?.orgQtr)) {
        let quarter = '';
        const orgQtr = await dispatch(getMaxQuarterValue());
        if (orgQtr?.status === STATUS_MSG && orgQtr?.message === SUCCESS_MSG) {
          const receivedQuarter = orgQtr?.maxQuarterVO;
          if (receivedQuarter) {
            quarter = receivedQuarter;
          }
        }
        newState.quarterValue = quarter;
        newState.orgQtr = quarter;
      }
      setInvQtrnotPaidScrData(newState);
    }
  };

  // get rebate program
  React.useEffect(() => {
    getRebateProgram(requestCurrentDisData?.planTypeCd);
  }, [requestCurrentDisData?.planTypeCd]);
  // Plan type useEffect
 React.useEffect(() => {
  if (extraState.searchPage && userDefaults && Object.keys(userDefaults).length > 0) {
    dispatch(getPlanTypeValues({}));
    dispatch(
      setExtraStateForInvoiceForQtrNotPaid({
        ...extraState,
        searchPage: false,
      })
    );
    const newState = {
      planTypeCd: userDefaults?.planTypeCd || 'FD',
      rebateProgramCd: userDefaults?.rebateProgramCd || '-1',
    };
    setInvQtrnotPaidScrData(newState);
  }
}, [extraState.searchPage, userDefaults]);

  //  setting radioList from planList Api
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  // tab Highlighter for Error message
  React.useEffect(() => {
    if (getErrorMsg?.length > 0) {
      tabHighLigther('/reqInvoicesQtrnotPaid', true);
    } else {
      tabHighLigther('/reqInvoicesQtrnotPaid', false);
    }
  }, [JSON.stringify(getErrorMsg)]);

  // onChange fn
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg || [];
    const newState = _.cloneDeep(requestCurrentDisData);
    newState[name] = value;
    if (name === 'planTypeCd') {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
      );
      newState.rebateProgramCd = '-1';
      newState.rebateName = '';
      const unique = [...new Set(localErr)];
      dispatch(dispatchErrorMsgInvQtrnotPaid(unique));
    }
    if (name === 'rebateProgramCd') {
      const getRebate =
        !_.isEmpty(rebateProgramList) && value
          ? _.filter(rebateProgramList, (l) => l.id === value)
          : [];
      const newVal = !_.isEmpty(getRebate)
        ? getRebate[0]
        : { id: '-1', name: '' };
      newState.rebateName = newVal.name;
    }
    setInvQtrnotPaidScrData(newState);
  };

  // //FILTERING Select option
  // const getFilterData = () => {
  //   const allData = resultList?.rebateInvoicesforQuarterNotPaidReportVO || [];

  //   let filterData = [];
  //   if (payValue === 'Bal>0') {
  //     filterData = allData.filter((data) => {
  //       return data.balance > 0;
  //     });
  //   }

  //   if (payValue === 'NoPayRec') {
  //     filterData = allData.filter((data) => {
  //       return data.payments === 0;
  //     });
  //   }
  //   if (payValue === 'Amt>PerDue') {
  //     if (!isNaN(amtPercent)) {
  //       filterData = allData.filter((data) => {
  //         if (data.total != null) {
  //           return (
  //             data.amount_Due > (parseFloat(amtPercent) / 100) * data.total
  //           );
  //         }
  //       });
  //     }
  //   }

  //   //checkboxes filtering

  //   let exUnThreshMailed = [];
  //   let incZeroURA = [];
  //   let excDecBalWtnOff = [];
  //   if (
  //     checkBoxValues.exUnThreshMailed ||
  //     checkBoxValues.incZeroURA ||
  //     checkBoxValues.excDecBalWtnOff
  //   ) {
  //     if (checkBoxValues.exUnThreshMailed) {
  //       exUnThreshMailed = filterData.filter((data) => {
  //         return !(data.underthreshold === 1) && !(data.mailed === null);
  //       });
  //     }
  //     if (checkBoxValues.incZeroURA) {
  //       incZeroURA = filterData.filter((data) => {
  //         return data.non_zero_ura > 0;
  //       });
  //     }

  //     if (checkBoxValues.excDecBalWtnOff) {
  //       excDecBalWtnOff = filterData.filter((data) => {
  //         return ['WO', 'DB', 'DBK'].indexOf(data.status) === -1;
  //       });
  //     } else {
  //       filterData = [
  //         ...new Set([...exUnThreshMailed, ...incZeroURA, ...excDecBalWtnOff]),
  //       ];
  //     }
  //   } else {
  //     filterData = [
  //       ...new Set([
  //         ...filterData,
  //         ...exUnThreshMailed,
  //         ...incZeroURA,
  //         ...excDecBalWtnOff,
  //       ]),
  //     ];
  //   }
  //   return filterData;
  // };

  // //set filtered data for checkbox nd Radio option
  // React.useEffect(() => {
  //   // setFilterData(getFilterData());
  // }, [
  //   payValue,
  //   amtPercent,
  //   checkBoxValues.exUnThreshMailed,
  //   checkBoxValues.incZeroURA,
  //   checkBoxValues.excDecBalWtnOff,
  // ]);

  const handleChangePayValues = (e) => {
    setPayValue(e.target.value);
  };

  // onchange on checkboxes
  const handleOnChangeChecks = (value, name) => {
    setCheckBoxValues({
      ...checkBoxValues,
      [name]: value,
    });
  };

  // on blur functionality on field level
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];

    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
        );
      }
    }
    if (type === 'quarter') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        localErr = localErr?.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        if (checkQuarterValidation(value)) {
          localErr = localErr?.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          setInvQtrnotPaidScrData({
            quarterValue: autoFormateDate(value?.toUpperCase()),
          });
        } else {
          localErr = localErr.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
          });
        }
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      }
    }

    if (
      (payValue === 'Amt>PerDue' &&
        type === 'amtPercent' &&
        isNaN(amtPercent)) ||
      parseInt(amtPercent) > 100
    ) {
      localErr = localErr.filter((item) => item.field !== 'amtPercent');
      localErr.push({
        field: 'amtPercent',
        errorType: 'required',
        message: PERCENT_ALLOWED_AMOUNT_REQ_LESS_THAN_100,
      });
    } else {
      localErr = localErr.filter((item) => item.field !== 'amtPercent');
    }

    localErr = localErr.filter((item) => item.field !== 'noData');

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgInvQtrnotPaid(unique));
  };

  // onclick handler on search button
  const clickHandlerOnProcess = async () => {
    let localErr = getErrorMsg || [];
    if (getErrorMsg.length > 0) {
    } else if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    } else {
      localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
    }
    if (
      payValue === 'Amt>PerDue' &&
      amtPercent !== '' &&
      parseInt(amtPercent) > 100
    ) {
      localErr = localErr.filter((item) => item.field !== 'amtPercent');
      localErr.push({
        field: 'amtPercent',
        errorType: 'required',
        message: PERCENT_ALLOWED_AMOUNT_REQ_LESS_THAN_100,
      });
    } else {
      localErr = localErr.filter((item) => item.field !== 'amtPercent');
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgInvQtrnotPaid(unique));
    // Variable to get fullname of rebate program from rebate program list(selectList)
    let rebateProgrameName =
      rebateProgramList.find(
        (item) => item.rebateProgramCd === state.rebateProgramCd
      ) || {};
    rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
      rebateProgrameName?.shortDescr || ''
    }`;
    dispatch(
      dispatchDisplayInputField({
        rebateProgram: state?.rebateProgramCd,
        quarter: state?.quarterValue,
        payValue: payValue,
        amtPercent: amtPercent,
        exUnThreshMailed: checkBoxValues.exUnThreshMailed,
        incZeroURA: checkBoxValues.incZeroURA,
        excDecBalWtnOff: checkBoxValues.excDecBalWtnOff,
        rebateProgrameName,
      })
    );
    // set date format as per UI

    const selectedRadioButton = {
      'Bal>0': 'BALANCE',
      NoPayRec: 'PAYMENTS',
      'Amt>PerDue': 'PERCENT',
    };
    const payForDetail = {
      rebateProgramCd: state.rebateProgramCd,
      retainPrintQtr: state.quarterValue,
      checkRadioButton: selectedRadioButton[payValue],
      includeZeroUra: checkBoxValues.incZeroURA ? 1 : 0,
      balanceWrittenOff: checkBoxValues.excDecBalWtnOff ? 1 : 0,
      underThresholdNotMailed: checkBoxValues.exUnThreshMailed ? 1 : 0,
      percentageInput: payValue === 'Amt>PerDue' ? amtPercent : null,
    };
    const filterCriteria = {
      payValue: payValue,
      amtPercent: amtPercent,
      exUnThreshMailed: checkBoxValues.exUnThreshMailed,
      incZeroURA: checkBoxValues.incZeroURA,
      excDecBalWtnOff: checkBoxValues.excDecBalWtnOff,
    };

    if (unique.length > 0) {
      return false;
    }
    const processBtnResult = await dispatch(
      getInvoiceQuarternotPaid(payForDetail, filterCriteria)
    );

    const response = processBtnResult && processBtnResult.payload;
    if (
      response &&
      response?.data?.rebateInvoicesforQuarterNotPaidReportVO &&
      response?.data?.rebateInvoicesforQuarterNotPaidReportVO.length > 0
    ) {
      tabHighLigther(navigateToRequest, false);

      const Obj = {};

      dispatch(invoicesQtrnotPaidDetailObj(Obj));
      redirectURLLink(
        '/invoicesforQtrnotPaidDetail',
        'Display Invoice Quarter not Paid Rpt',
        history,
        dispatch
      );
    } else {
      let localErr = getErrorMsg || [];
      localErr = localErr.filter((item) => item.field !== 'noData');
      localErr.push({
        field: 'noData',
        message: NO_DATA,
      });
      const unique = [...new Set(localErr)];
      dispatch(dispatchErrorMsgInvQtrnotPaid(unique));
    }
  };

  return (
    <div className="tBillPanel custom-check tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="Summary Reports"
        parent2="Invoices for Quarter Not Paid"
      />
      {getErrorMsg?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              getErrorMsg?.length > 0
                ? _.map(getErrorMsg, (l) => l.message)
                : []
            ),
          ]}
        />
      ) : null}
      {state?.planTypeCd && (
      <div className="row ml-0">
        <div className="col-4 frr-two-col-radio">
          <RadioGroupComponent
            id="filter-plan-by-radio-btn-action"
            data-testid="filter-planType-radio-btn"
            labelName={commonConstant.radioGroupLabelNamePlan}
            required={false}
            optionList={radioList || []}
            defaultValue={state && state.planTypeCd}
            filterAction={(e) => {
              handleOnChangeEvent(e, 'planTypeCd');
            }}
            className="log-batch-filter-radio frr-checkInvoiceRadio"
          />
        </div>
        <div className="col-8">
          <div className="frr-mui-custom-form-width-45per">
            <div className="form-wrapper">
              <div className="mui-custom-form with-select">
                <TextField
                  id="rebate_program"
                  data-testid="rebate_program-generate-inv"
                  label={commonConstant.rebateProgramLabelName}
                  fullWidth
                  select
                  required
                  placeholder=""
                  inputProps={{ maxLength: 11, id: 'rebate_program' }}
                  onBlur={(e) =>
                    handleOnblurEvent('rebateProgramCd', e.target.value)
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={state && state.rebateProgramCd}
                  onChange={(e) =>
                    handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                  }
                  className={getErrorMsg?.length > 0
                    ? _.map(getErrorMsg, (l) =>
                      l.field === 'rebateProgramCd' ? 'mandate-fields' : null
                    ).filter(Boolean).join(' ')
                    : ''}
                  helperText={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'rebateProgramCd' ? l.message : null
                        )
                      : null
                  }
                  error={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'rebateProgramCd' ? l.message : null
                        )
                      : null
                  }
                >
                  <MenuItem
                    key=""
                    value="-1"
                    className="frr-dropdown-blank-item"
                  />
                  {rebateProgramList &&
                  rebateProgramList.length &&
                  rebateProgramList.length > 0
                    ? rebateProgramList.map((item) => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })
                    : null}
                </TextField>
              </div>
              <div className="mui-custom-form with-select">
                <TextField
                  data-testid="check_by_invoice_quater"
                  id="Quarter"
                  required
                  label={commonConstant.quarterLabelName}
                  fullWidth
                  placeholder=""
                  inputProps={{ maxLength: 6, id: 'Quarter' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={state && state.quarterValue}
                  onChange={(e) => {
                    handleOnChangeEvent(e.target.value, 'quarterValue');
                  }}
                  className={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field == 'quarter' ? 'mandate-fields' : null
                        )
                      : null
                  }
                  onBlur={(e) => handleOnblurEvent('quarter', e.target.value)}
                  helperText={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'quarter' ? l.message : null
                        )
                      : null
                  }
                  error={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field == 'quarter' ? l.message : null
                        )
                      : null
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      )}
      <div className="row ml-2 mt-2">
        <div className="col-6 pr-0 mt-1">
          <fieldset className="radioBtnGroup custom-fieldset h-100">
            <legend className="same-font-family">
              {commonConstant.radioGroupLabelNameSelectOpt}{' '}
            </legend>

            <RadioGroup
              className="row ml-1"
              aria-label="gender"
              data-testid="IQNP-radio-gender"
              name="gender"
              value={payValue}
              onChange={handleChangePayValues}
              onBlur={(e) => handleOnblurEvent('amtPercent', e.target.value)}
            >
              <FormControlLabel
                value="Bal>0"
                control={<Radio />}
                label="Balance > Zero"
              />
              <FormControlLabel
                value="NoPayRec"
                control={<Radio />}
                label="No Payment Received"
              />
              <div className="row col-10  ">
                <FormControlLabel
                  value="Amt>PerDue"
                  control={<Radio />}
                  label="Amount Owed greater than "
                  id="Amount Owed greater than "
                  fullWidth
                />
                <TextField
                  id="percent amount"
                  label="percent amount"
                  variant="filled"
                  data-testid="RIQNP-rebate_program"
                  className="searchInput input-count frr-display-hidden-label"
                  required
                  disabled={payValue !== 'Amt>PerDue'}
                  size="small"
                  value={amtPercent}
                  onChange={(e) => setAmtPercent(e.target.value)}
                  onBlur={(e) =>
                    handleOnblurEvent('amtPercent', e.target.value)
                  }
                  // error={
                  //   getErrorMsg?.length > 0
                  //     ? _.map(getErrorMsg, (l) =>
                  //         l.field == 'amtPercent' ? l.message : null
                  //       )
                  //     : null
                  // }
                />
                <span>&nbsp;% of Total</span>
              </div>
            </RadioGroup>
          </fieldset>
        </div>
        <div className="col-5 frr-checkbox-100per-width mt-3 ml-2">
          <div className="form-wrapper db" controlId="formBasicCheckbox">
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={checkBoxValues.exUnThreshMailed}
                  className=""
                />
              }
              data-testid="IQNP-exclude-threshold"
              label="Exclude under Threshold/Not Mailed"
              onChange={(e) =>
                handleOnChangeChecks(e.target.checked, 'exUnThreshMailed')
              }
            />
            <FormControlLabel
              className=""
              control={
                <Checkbox
                  color="primary"
                  checked={checkBoxValues.incZeroURA}
                  className=""
                />
              }
              data-testid="IQNP-include-zero-URA"
              label="Include Zero URA"
              onChange={(e) =>
                handleOnChangeChecks(e.target.checked, 'incZeroURA')
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={checkBoxValues.excDecBalWtnOff}
                  className=""
                />
              }
              data-testid="IQNP-exclude-decelared-balance"
              label="Exclude Declared balanced/Written off"
              onChange={(e) =>
                handleOnChangeChecks(e.target.checked, 'excDecBalWtnOff')
              }
            />
          </div>
        </div>
      </div>
      <div className="col-12">
        <div className="text-right mt-2">
          <Button
            className="btn btn-success btn-search"
            data-testid="view_detail_searchbtn"
            type="button"
            onClick={() => {
              clickHandlerOnProcess();
            }}
          >
            {' '}
            <SVGComponent iconName="Icon-search" /> {'  '} Search
          </Button>
        </div>
      </div>
    </div>
  );
}
export default withRouter(RequestInvoicesQtrnotPaid);
